import React from 'react';

import { Route, Switch } from "react-router-dom";

import UserRequestsListing from './user_requests.list';
import UserRequestView from './user_requests.view';
import UserRequestViewPerDay from './user_requests_per_day.list';

import store from './filterStore';

const UserRequestsRouter = ({ match }) => {
  return (
    <div>
      <Switch>
        <Route
          exact
          path={match.path}
          render={() => <UserRequestsListing store={store} />}
        />
        <Route
          path={`${match.path}/per_day`}
          component={UserRequestViewPerDay} />
        <Route
          path={`${match.path}/:id`}
          component={UserRequestView} />
    </Switch>
  </div>
  );
};

export default UserRequestsRouter;
